import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/setting/role',
  title: '角色管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
